import React from 'react';
import { styled } from '@linaria/react';
interface AudioPlayerProps {
  base64Data: string;
  format?: string;
}
const AudioContainer = /*#__PURE__*/styled("div")({
  name: "AudioContainer",
  class: "omponents__Common__AudioPlayer__AudioPlayer_tsx-AudioContainer-arw91yw"
});
export const AudioPlayer: React.FC<AudioPlayerProps> = ({
  base64Data,
  format = 'wav'
}) => {
  if (!base64Data) {
    return null;
  }
  const audioSrc = `data:audio/${format};base64,${base64Data}`;
  return <AudioContainer>
      <audio controls src={audioSrc}>
        <track kind="captions" />
        Your browser does not support the audio element.
      </audio>
    </AudioContainer>;
};

require("./AudioPlayer.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./AudioPlayer.tsx");